<template>
  <v-app>
    <v-content :class="routeName">
      <v-container fluid>
        <div id="loader">
          <div class="text-xs-center">
            <v-progress-circular
              :size="50"
              color="#008485"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>
        <app-header key="app-header"></app-header>
        <keep-alive v-if="loaded" include="home">
          <router-view/>
        </keep-alive>
        <v-dialog
          v-model="showPopup"
          width="600"
          class="test"
          attach=".v-content"
        >
          <v-card class="old-browser">
            <v-card-title
              class="headline old-browser"
              primary-title
            >
            </v-card-title>
            <v-card-text class="old-browser">
              <p>
                {{ $t('old_browser_1') }}
              </p>
              <p>
                {{ $t('old_browser_2')}}
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
        <app-footer></app-footer>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import RepositoryFactory from "@/services/RepositoryFactory";
  const ProvinceService = RepositoryFactory.get('province');
  const StorageService = RepositoryFactory.get('storage');
  import {UAParser} from 'ua-parser-js';
  const AppVersion = '1.1.4';
  console.log('App Version: ' + AppVersion);

  export default {
    name: 'App',
    components: {},
    data() {
      return {
        routeName: null,
        loaded: false,
        showPopup: false,
      }
    },
    async mounted() {
      let parser = new UAParser();

      let agent = parser.getResult();
      if (agent.browser.name == 'IE' && agent.browser.major <= 11 || agent.browser.name == "Edge" && agent.browser.major < 17) {
        this.showPopup = true;
      }

      await this.loadDefaultConfiguration();

      // Set language
      const language = await this.$store.dispatch('loadCurrentLanguage');
      if (language) {
        this.$i18n.locale = language;
      }

      this.routeName = this.$router.app._route.name;
      let navigationMenu = [
        {title: 'Home', icon: 'more', path: '/'},
        {
          title: 'FAQs', icon: '', path: '#', child: [
            {title: 'FAQs', icon: '', path: '/faq'},
            {title: 'About Rankings', icon: '', path: '/about-rankings'},
          ]
        },
        {title: 'PDFS', icon: '', path: '/pdfs'},
      ];
      this.$store.commit('SET_NAVIGATION_MENU', navigationMenu);
      if (this.$store.state.currentMapProvince === '') {
        this.$store.commit('CURRENT_MAP_PROVINCE', StorageService.getItem("currentMapProvince"));
      }
    },
    methods: {
      async loadDefaultConfiguration() {
        // Load Latest Year.
        let actionWrapper = document.querySelector('.application--wrap');
        let latestYear;
        let latestYearResponse;
        if(actionWrapper) {
          actionWrapper.classList.add('loading');
        }
        latestYearResponse = await ProvinceService.getProvinceLatestYear();
        if(actionWrapper) {
          actionWrapper.classList.remove('loading');
        }
        latestYear = latestYearResponse.data.data;
        StorageService.setItem('latestYear', JSON.stringify(latestYear));

        return Promise.all([latestYearResponse]).then(() => {
          this.loaded = true;
        });
      }
    }
  }

</script>

<style lang="scss">
  @import 'assets/scss/main';
</style>
